// HFLedger/Settings.js

import React, { useState } from 'react';
import axios from 'axios';
import './Settings.css';
import CategoryManager from './CategoryManager';
import CurrencyConverter from './CurrencyConverter';
import AccountManager from './AccountManager';

function Settings({ user, language, SERVER_ROOT, settings, onSettingsChanged }) {
  const [userSettings, setUserSettings] = useState(settings);

  // 설정 변경 핸들러
  const handleSettingsChange = async (key, value) => {
    try {
      // 서버에 설정 업데이트
      await axios.post(`${SERVER_ROOT}/api/hfl/settings`, {
        user_id: user.uid,
        [key]: value
      });
      
      // 로컬 상태 업데이트
      const updatedSettings = {
        ...userSettings,
        [key]: value
      };
      
      setUserSettings(updatedSettings);
      
      // 부모 컴포넌트에 변경 알림
      if (typeof onSettingsChanged === 'function') {
        onSettingsChanged(updatedSettings);
      }
    } catch (err) {
      console.error(`Error updating ${key} setting:`, err);
    }
  };

  return (
    <div className="hfledger-settings-container">
      {/* <h2>{language === 'KR' ? '설정' : 'Settings'}</h2> */}
      
      {/* 계좌 관리 섹션 */}
      <div className="hfledger-settings-section">
        <h3>{language === 'KR' ? '계좌 관리' : 'Manage Accounts'}</h3>
        <AccountManager 
          user={user} 
          language={language} 
          SERVER_ROOT={SERVER_ROOT}
          settings={userSettings}
        />
      </div>
      
      {/* 카테고리 관리 섹션 */}
      <div className="hfledger-settings-section">
        <h3>{language === 'KR' ? '카테고리 관리' : 'Manage Categories'}</h3>
        <CategoryManager 
          user={user} 
          language={language} 
          SERVER_ROOT={SERVER_ROOT}
          settings={userSettings}
        />
      </div>
      
      {/* 통화 변환기 섹션 */}
      <div className="hfledger-settings-section">
        <h3>{language === 'KR' ? '통화 변환기' : 'Currency Converter'}</h3>
        <CurrencyConverter 
          user={user} 
          language={language} 
          SERVER_ROOT={SERVER_ROOT}
          settings={userSettings}
        />
      </div>
      
      {/* 사용자 설정 섹션 */}
      <div className="hfledger-settings-section">
        <h3>{language === 'KR' ? '사용자 설정' : 'User Preferences'}</h3>
        <div className="hfledger-user-preferences">
          <div className="hfledger-form-group">
            <label htmlFor="default-currency">
              {language === 'KR' ? '기본 통화' : 'Default Currency'}
            </label>
            <select 
              id="default-currency"
              value={userSettings.default_currency}
              onChange={(e) => handleSettingsChange('default_currency', e.target.value)}
            >
              <option value="KRW">KRW (₩)</option>
              <option value="USD">USD ($)</option>
              <option value="EUR">EUR (€)</option>
              <option value="JPY">JPY (¥)</option>
              <option value="CNY">CNY (¥)</option>
              <option value="GBP">GBP (£)</option>
            </select>
          </div>
          
          <div className="hfledger-form-group">
            <label htmlFor="theme-preference">
              {language === 'KR' ? '테마' : 'Theme'}
            </label>
            <select 
              id="theme-preference"
              value={userSettings.theme_preference}
              onChange={(e) => handleSettingsChange('theme_preference', e.target.value)}
            >
              <option value="light">{language === 'KR' ? '라이트' : 'Light'}</option>
              <option value="dark">{language === 'KR' ? '다크' : 'Dark'}</option>
              <option value="system">{language === 'KR' ? '시스템 설정' : 'System'}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;